<template>
  <div class="commission">
    <el-form label-width="120px">
      <el-row>
        <el-col :span='4'><div style="height:32px"></div></el-col>
        <el-col :span="10">
          <el-form-item label="提成名称：">{{cueRowData.feeName | filterRow}}</el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="岗位：">{{cueRowData.postId | filterPostId(infolist.postIdData) | filterRow}}</el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span='4'><div style="height:32px"></div></el-col>
        <el-col :span="10">
          <el-form-item label="提成类型：">{{cueRowData.isTeam == 1 ?'团队提成':'个人提成'}}</el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="生效时间：">{{cueRowData.startDate | filterRow}}</el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span='4'><div style="height:32px"></div></el-col>
        <el-col :span="10">
          <el-form-item label="提成来源：">{{sourceType(cueRowData.sourceList)}}</el-form-item>
        </el-col>
      </el-row>
      <el-row class="titRoyalty">
        <el-col :span='4'><div style="height:32px"></div></el-col>
        <el-col :span="10">
          <el-form-item label="月度业绩范围（¥）" label-width="170px"></el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="提成（%）"></el-form-item>
        </el-col>
      </el-row>
      <el-row class="titRoyalty" v-for='(i,index) in cueRowData.detailList' :key="'commission-'+index">
        <el-col :span='4'><div style="height:32px"></div></el-col>
        <el-col :span="10">
          <el-form-item label-width='20px'>{{i.bottom}}&nbsp;{{(index == cueRowData.detailList.length-1)?'+':'-'}}&nbsp;{{i.top == 10000000 ? '':i.top}}</el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label-width='20px'>{{i.feeFactor}}%</el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import infolist from '@/assets/js/info'
import vFilter from "@/assets/js/filter";
import Vue from "vue";
for (let key in vFilter) {
  Vue.filter(key, vFilter[key]);
}

export default {
  props: ['cueRowData'],
  data() {
    return {
      infolist:infolist,
    };
  },
  computed: {
    sourceType(){
      return function(val){
        let data = [];
        if(val){
          for(let i of val){
            if(i.sourceId && data.indexOf(i.sourceId) == -1){
              data.push(vFilter.filterScorce(i.sourceId));
            }
          }
          return data.length ? data.join('、'):'无';
        }
      }
    }
  },
  methods: {
    
  }
};
</script>
<style lang="less" scoped>
.commission {
  width: 100%;
  overflow: hidden;
  text-align: center;  
  .el-form-item {
    margin-bottom: 0;
  }
}
</style>
<style lang="less">
.commission {
  .el-form-item__content {
    text-align: left;
  }
  .el-form-item__label{
      text-align:left
  }
}
</style>





// WEBPACK FOOTER //
// src/components/basicDataCenter/commission.vue